import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/icons/add-circle.svg'


const _hoisted_1 = { class: "row gx-0 mb-30" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "filter-right d-flex align-items-center justify-content-md-end flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FilterModal = _resolveComponent("FilterModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-md-6" }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: _ctx.btnLink,
            class: "btn style-one"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Create " + _toDisplayString(_ctx.btnText) + " ", 1),
              _cache[0] || (_cache[0] = _createElementVNode("img", {
                src: _imports_0,
                alt: "Image"
              }, null, -1))
            ]),
            _: 1,
            __: [0]
          }, 8, ["to"])
        ])
      ])
    ]),
    _createVNode(_component_FilterModal)
  ], 64))
}